// extracted by mini-css-extract-plugin
export var cookieSetting = "SettingItem-module--cookieSetting--kzshJ";
export var cookieDisclaimer = "SettingItem-module--cookieDisclaimer--MHxwj";
export var switchContainer = "SettingItem-module--switchContainer--tV2ap";